import { render, staticRenderFns } from "./DeclareApplyDetail.vue?vue&type=template&id=7a20fa40&scoped=true&"
import script from "./DeclareApplyDetail.vue?vue&type=script&lang=js&"
export * from "./DeclareApplyDetail.vue?vue&type=script&lang=js&"
import style0 from "./DeclareApplyDetail.vue?vue&type=style&index=0&id=7a20fa40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a20fa40",
  null
  
)

export default component.exports